import { pbx_module_breadcrumbs } from './_module';

const index = pbx_module_breadcrumbs
  .extend('pbx.media.index')
  .add('pbx.breadcrumb.media.index', { name: 'pbx.media.index' });

export const pbx_media_breadcrumbs = [index];
